<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style lang="scss">
  @import "./../stylesheets/screen";
</style>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'The trade hub for chemical industry professionals',
      titleTemplate: '%s | SPOT • CHEMI'
    }
  }
</script>



// WEBPACK FOOTER //
// client/components/App.vue